import type { AppConfigDefinition, configCollectionMode } from './types'


export const DefaultConfig: AppConfigDefinition = {
	detailsUrlTarget: null,
	hideHeaderActions: false,
	hideHeaderFilters: false,
	hideHeaderSearch: false,
	hideDeleteActions: false,
	hideHeader: false,
    hidePagination: false,
    hideActions: false,
	hideFeedback: false,
	hiddeAssistantComponent: false,
	hideWorkflowStates: false,
	forceDetailsId: null,
	disabledLnguageSwitcher: false,
    editmode: false,
	showOnlyPostquiz: false,
    models: false,
    urls: {
        getList: null,
        newmodels: null,
        editmodels: null,
        newPackage: null,
        editPackage: null,
		authoringStatusList: null,
		reviewStatusList: null,
		publishingStatusList: null,
		statuses: null,
        packageType: null,
		print: {
			buttonLabel: '',
			toolTipLabel: '',
			openMode: 'modal',
		},
		authoringStatuscfg:{
			authoringStatus: null,
			enabledAuthoringStatus: true,
			authoringDisabled: false
		},
		reviewStatuscfg:{
			reviewStatus: null,
			enabledReviewStatus: true,
			reviewDisabled: false
		},
		publishingStatuscfg:{
			publishingStatus: null,
			enabledpublishingStatus: true,
			publishingDisabled: false
		},
		assistantModeButtons:{
			configButton:{
				enabled: true,
				configAssistantLink: '',
			},
			finishButton:{
				enabled: true,
				finishAssistantLink: '',
			},
			complainceButton:{
				enabled: true,
				complainceAssistantLink: '',
			},
			helpSupportAssistantButton:{
				enabled: true,
			},
			feedbackAssistantButton:{
				enabled: true,
			},
			reportButton:{
				enabled: true,
				reportAssistantLink: '',
			},			
			readCallAssistantButton:{
				enabled: true,
				readCallAssistantLink: '',
				toolTipLabel:'',
				buttonLabel:''
			},			
			callAssistantButton:{
				enabled: true,
				modal: true,
				url: ''
			},
		},
		feedback: {
			enabled: true,
			modal: true,
			url: '',
			listUrl: '',
			toolTipLabel:'',
			buttonLabel:''
		},
		prequiz: {
			modal: false,
			openMode: 'modal',
		},
		postquiz: {
			modal: false,
			openMode: 'modal',
		},
		keymessage: {
			modal: false,
			openMode: 'modal',
		},
		presentation: {
			openMode: 'modal',
		},
		playerMode: {
			openMode: 'route',
		},
	},
	//defaultLng: 'de',
	publishingStatus:'',
	authoringStatus:'',
	medicalSpeciality:'',
	studyType:'',
	outcomeType:'',
	targetAudience:'',
	collectionMode:'audience',
	dashboardFilter: '',
	latestDays: 14,
	testYourself: 'n',
	PAGE_REQ_ID:'888'

}

// export const AppConfig: AppConfigDefinition = { ...DefaultConfig, ...window.MjcConfig }
